module.exports = __webpack_public_path__ + "img/icon_refresh.ffc16943.svg";